/**
 * reminderPortal.ts — F 490's marker for a portal a surface OPENED.
 *
 * WHY THIS EXISTS
 * ---------------
 * A surface that renders an overlay in a PORTAL (Mantine's `Popover` does
 * this by default) has a problem that is easy to get wrong: the portal's
 * DOM is not a descendant of the surface, so the surface's own
 * outside-click handler treats a click INSIDE its own overlay as a click
 * OUTSIDE the surface.
 *
 * MEASURED on production, in `TaskDetailPane`: the reminder clock opens a
 * Popover, the Popover's dropdown is portalled to the document body, and
 * the pane's `paneRef.contains(target)` was FALSE for a click on the
 * popover's own Save button. So the mousedown closed the whole pane, the
 * popover unmounted with it, and the `click` never landed. A user could
 * not use the reminder popover at all.
 *
 * THE FIX
 * -------
 * The overlay marks itself with a data attribute, and the surface's
 * outside-click handler walks `event.composedPath()` looking for that
 * marker. `composedPath` is the right tool because it lists the event's
 * ancestors ACROSS the portal boundary — a `contains()` test can never
 * see a portal's contents from outside it.
 *
 * The attribute is a CONSTANT, not a literal, so the surface and the
 * overlay cannot drift apart: a typo in the attribute name would silently
 * restore the bug, and a constant cannot be typo'd in two places.
 */

/** The attribute a portal-rendered overlay carries. */
export const REMINDER_PORTAL_ATTR = 'data-fv-portal-owner';

/**
 * Mark an element as belonging to the surface that opened it.
 *
 * Returns the props to spread onto the overlay's root element.
 */
export function portalOwnerProps(): Record<string, string> {
  return { [REMINDER_PORTAL_ATTR]: 'true' };
}
